import { combineReducers } from 'redux';
import routing from './routing';
import payments from './payment';
import agent from './agent';
import quote from './quote';
import travelDetails from './travelDetails';
import employeeDetails from './employeeDetails';
import nextOfKin from './nextOfKin';
import payloadCollection from './payloadCollection';

export const travelUg = combineReducers({
    routing,
    payments,
    agent,
    quote,
    travelDetails,
    employeeDetails,
    nextOfKin,
    payloadCollection,
});
